import React, { useState, useEffect, useRef } from "react";
import Tree from "react-d3-tree";
import { getHierarchy } from "../services/organizationHierarchyServices";
import { companyID } from "../auth";
import "./organizationHierarchy.css";

const containerStyles = {
  width: "100%",
  height: "600px",
  border: "1px solid #ddd",
  padding: "10px",
  position: "relative",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

const getDynamicWidth = (texts, padding = 30, minWidth = 150) => {
  const canvas = document.createElement("canvas");
  const context = canvas.getContext("2d");

  const maxTextWidth = texts.reduce((maxWidth, { text, fontSize }) => {
    context.font = `${fontSize}px Arial`;
    return Math.max(maxWidth, context.measureText(text).width);
  }, 0);

  return Math.max(minWidth, maxTextWidth + padding);
};

const renderCustomNode = ({ nodeDatum, toggleNode }) => {
  const texts = [
    { text: nodeDatum.name || "-", fontSize: 14 },
    { text: nodeDatum.department || "-", fontSize: 12 },
    { text: nodeDatum.designation || "-", fontSize: 12 },
  ];

  const rectWidth = getDynamicWidth(texts);

  return (
    <g onClick={toggleNode}>
      <rect
        width={rectWidth}
        height={70}
        rx={10}
        ry={10}
        fill="white"
        x={-rectWidth / 2}
        y="-30"
        style={{ cursor: "pointer" }}
      />
      <text x="0" y="-10" textAnchor="middle" stroke="none" fontWeight="bold">
        {nodeDatum.name || "-"}
      </text>
      <text x="0" y="10" textAnchor="middle" stroke="none" fontSize="12">
        {nodeDatum.department || "-"}
      </text>
      <text x="0" y="25" textAnchor="middle" stroke="none" fontSize="12">
        {nodeDatum.designation || "-"}
      </text>

      {nodeDatum.children && (
        <text
          textAnchor="middle"
          fill="gray"
          cursor="pointer"
          onClick={toggleNode}
        ></text>
      )}
    </g>
  );
};

const OrganizationHierarchy = () => {
  const [data, setData] = useState(null);
  const treeContainerRef = useRef(null);
  const company_id = companyID();

  const fetchData = async (companyId) => {
    const hierarchyData = await getHierarchy(companyId);
    setData(hierarchyData.length ? hierarchyData[0] : null);
  };

  useEffect(() => {
    if (company_id) {
      fetchData(company_id);
    }
  }, []);

  return (
    <div className="tab-pane fade" id="org_hierarchy">
      <div ref={treeContainerRef} style={containerStyles}>
        {data ? (
          <Tree
            data={data}
            orientation="vertical"
            translate={{ x: 300, y: 50 }}
            zoomable={true}
            scaleExtent={{ min: 0.5, max: 2 }}
            draggable={true}
            separation={{ siblings: 1, nonSiblings: 1 }}
            pathFunc="step"
            collapsible={true}
            renderCustomNodeElement={renderCustomNode}
            nodeSize={{ x: 200, y: 110 }}
            // dimensions= {{ height: 200,  width: 1100 }}
          />
        ) : (
          <p className="text-center">Hierarchy Not Available !</p>
        )}
      </div>
    </div>
  );
};

export default OrganizationHierarchy;
